<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->
      <div class="forms card rounded">
        <div
          v-bind:class="[closed ? 'close' : '']"
          class="mb-4 bg-warning p-3 text-dark"
          v-if="isSuccessful === false"
        >
          <b>Error : {{ errorMessage }}</b>
          <i @click="close()" class="fas fa-close"></i>
        </div>
        <div v-else></div>
        <form @submit.prevent="approve()">
          <!-- <label>Asset Id</label>
          <input :value="asset.id" type="text" class="form-control" disabled /> -->

          <label>Asset Name</label>
          <input
            :value="asset.name"
            type="text"
            class="form-control"
            disabled
          />

          <label>Asset Purchase Date</label>
          <input
            :value="asset.purchaseDate.split('T')[0]"
            type="date"
            class="form-control"
            disabled
          />

          <label>Asset Purchase Amount</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">₦</span>
            </div>

            <input
              type="text"
              :value="new Intl.NumberFormat().format(asset.purchaseAmount)"
              class="form-control"
              disabled
            />
            <div class="input-group-append">
              <span class="input-group-text">.00</span>
            </div>
          </div>

          <label>Actual Asset Location</label>
          <input
            v-model="assetLocation"
            type="text"
            class="form-control"
            required
          />

          <label>Class Of Asset</label>
          <input
            v-model="assetClass"
            type="text"
            class="form-control"
            required
          />

          <label>Action Type</label>
          <select v-model="type" class="form-control mb-3" required>
            <option selected>Select</option>
            <option value="Reallocation">Reallocation</option>
            <option value="Disposal">Disposal</option>
            <option value="Transfer">Transfer</option>
          </select>

          <!-- <label>Sales Value</label>
          <input
            v-model="salesValue"
            type="number"
            class="form-control"
            required
          /> -->

          <label>Date Of {{ type }}</label>
          <input v-model="date" type="date" class="form-control" required />

          <div v-if="type == 'Reallocation' || type == 'Disposal'">
            <label>Asset Sales Value</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">₦</span>
              </div>

              <input
                type="text"
                @change="format1()"
                @click="salesValue = ''"
                v-model="salesValue"
                class="form-control"
              />
              <div class="input-group-append">
                <span class="input-group-text">.00</span>
              </div>
            </div>

            <label>Asset Accumulated Depreciation</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">₦</span>
              </div>

              <input
                type="text"
                @change="format2()"
                @click="accumulatedDepreciation = ''"
                v-model="accumulatedDepreciation"
                class="form-control"
              />
              <div class="input-group-append">
                <span class="input-group-text">.00</span>
              </div>
            </div>

            <!-- <label>Accumulated Depreciation</label>
          <input
            v-model="accumulatedDepreciation"
            type="number"
            class="form-control"
            required
          /> -->

            <label>Receipt Number</label>
            <input v-model="recieptNumber" type="number" class="form-control" />
          </div>
          <label>Admin Officer</label>
          <input v-model="adminOfficer" type="text" class="form-control" />

          <label>Fixed Asset Manager</label>
          <input
            v-model="assetManager"
            type="text"
            class="form-control"
            required
          />
          <div v-if="type == 'Transfer'">
            <label>{{ type }} Destination</label>
            <input v-model="destination" type="text" class="form-control" />
          </div>

          <label>User Comment</label>
          <textarea
            v-model="userComment"
            class="form-control mb-3"
            rows="3"
            required
          ></textarea>

          <label>Approval Submitted By</label>
          <input
            :value="user.email"
            type="text"
            class="form-control"
            disabled
          />
          <button
            v-if="loading == true"
            type="submit"
            class="btn btn-primary"
            disabled
          >
            Loading
            <div class="spinner-border spinner-border-sm" role="status">
              <span style="width: 2px" class="sr-only text-light"
                >Loading...</span
              >
            </div>
          </button>

          <button v-else type="submit" class="btn btn-primary">
            Approve {{ type }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
  },
  props: ["user", "BaseURL"],
  data() {
    return {
      loading: false,
      asset: {},

      assetClass: " ",
      assetLocation: " ",
      date: "0000-00-00",
      salesValue: "0",
      destination: "",
      type: " ",
      accumulatedDepreciation: "0",
      recieptNumber: 0,
      userComment: " ",
      assetManager: " ",
      adminOfficer: " ",

      isSuccessful: "",
      errorMessage: "",

      closed: "",
    };
  },

  methods: {
    format1() {
      this.salesValue = new Intl.NumberFormat().format(
        parseInt(this.salesValue.replace(",", ""))
      );
    },

    format2() {
      this.accumulatedDepreciation = new Intl.NumberFormat().format(
        parseInt(this.accumulatedDepreciation.replace(",", ""))
      );
    },

    approve() {
      this.loading = true;
      fetch(this.BaseURL + "/UserApproval", {
        method: "POST",
        body: JSON.stringify({
          assetId: this.$route.params.id,
          assetName: this.asset.name,
          classofAsset: this.assetClass,
          presentLocation: this.assetLocation,
          adminOfficer: this.adminOfficer,
          fixedAssetManager: this.assetManager,
          date: this.date,
          salesvalue: parseInt(this.salesValue.replace(",", "")),
          destination: this.destination,
          type: this.type,
          accumulatedDepreciation: parseInt(
            this.accumulatedDepreciation.replace(",", "")
          ),
          receiptNumber: this.recieptNumber,
          submittedBy: this.user.email,
          userComment: this.userComment,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.isSuccessful = data.isSuccessful;
          this.errorMessage = data.message;

          if (this.isSuccessful == true) {
            alert(this.asset.name + " Approved For " + this.type);
            window.location = "/approvals";
          } else {
            this.loading = false;
            alert(this.errorMessage);
          }
        });
    },

    close() {
      this.closed = true;
    },
  },

  beforeCreate() {
    if (localStorage.getItem("role") !== "User") {
      window.location = "/error";
    }
  },

  created() {
    fetch(this.BaseURL + "/getAssetById" + this.$route.params.id, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.asset = data;
      });
  },
};
</script>